/** Источник случайности: `crypto` браузера или подмена в тестах. */
export interface UuidSource {
  randomUUID?: () => string;
  getRandomValues?: (array: Uint8Array) => unknown;
}

/**
 * Новый UUID v4 — id одного нажатия «Создать» или «Добавить» (`generation_id`, ТЗ главной § 22.12).
 * `crypto.randomUUID` есть только в защищённом контексте: на прототипе по Wi-Fi
 * (`http://` с адресом в сети) его нет — тогда собираем v4 из `crypto.getRandomValues`.
 * Без alias-импортов: модуль проверяют тесты (`tests/home-composer.test.ts`).
 */
export function newUuid(source: UuidSource | undefined = globalThis.crypto): string {
  if (source && typeof source.randomUUID === 'function') return source.randomUUID();
  const bytes = new Uint8Array(16);
  if (source && typeof source.getRandomValues === 'function') {
    source.getRandomValues(bytes);
  } else {
    // Без crypto вовсе (старый движок) — id только различает нажатия, тайны в нём нет.
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // версия 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // вариант RFC 4122
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
